import type { QueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queries";

/** An applied invoice command changes views beyond the currently open bill. */
export async function invalidateInvoiceMutation(queryClient: QueryClient, invoiceId?: string) {
  await Promise.all([
    ...(invoiceId ? [queryClient.invalidateQueries({ queryKey: queryKeys.invoice(invoiceId) })] : []),
    queryClient.invalidateQueries({ queryKey: queryKeys.grid }),
    queryClient.invalidateQueries({ queryKey: queryKeys.offPremiseOpen }),
    queryClient.invalidateQueries({ queryKey: ["restaurant", "invoices", "history"] }),
    // P7.6: the waiting lane reads its bills' plates in one read, so any bill
    // command marks it stale, as it marked the bill it read.
    queryClient.invalidateQueries({ queryKey: ["restaurant", "invoices", "cashier-lane"] }),
    queryClient.invalidateQueries({ queryKey: ["restaurant", "kitchen-board"] }),
    queryClient.invalidateQueries({ queryKey: queryKeys.ingredients, exact: true }),
    // P7.4: the sidebar's Stock figure counts this list's out-or-low rows.
    queryClient.invalidateQueries({ queryKey: queryKeys.ingredientsReorderCount, exact: true }),
    queryClient.invalidateQueries({ queryKey: ["restaurant", "reports"] }),
    // P6b: a settled, written-off or reopened platform bill moves the
    // platforms' period totals as it moves Sales & costs.
    queryClient.invalidateQueries({ queryKey: ["restaurant", "aggregator-totals"] }),
    queryClient.invalidateQueries({ queryKey: queryKeys.shiftSummary }),
    queryClient.invalidateQueries({ queryKey: ["restaurant", "shifts"] }),
    queryClient.invalidateQueries({ queryKey: ["restaurant", "day-close"] }),
  ]);
}

/** Cost/recipe facts are shared by stock, the till and management reports. */
export async function invalidateRestaurantStock(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: queryKeys.ingredients, exact: true }),
    // P7.4: the sidebar's Stock figure counts this list's out-or-low rows.
    queryClient.invalidateQueries({ queryKey: queryKeys.ingredientsReorderCount, exact: true }),
    queryClient.invalidateQueries({ queryKey: queryKeys.menuItems }),
    queryClient.invalidateQueries({ queryKey: queryKeys.addonGroups }),
    queryClient.invalidateQueries({ queryKey: queryKeys.kitchenAvailability }),
    queryClient.invalidateQueries({ queryKey: ["restaurant", "reports"] }),
  ]);
}
